export const getDateUrgency = (deliveryDate: Date): 'overdue' | 'urgent' | 'normal' => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  // const deliveryDate = new Date(dateString);
  deliveryDate.setHours(0, 0, 0, 0);
  
  const diffTime = deliveryDate.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays < 0) {
    return 'overdue';
  } else if (diffDays < 2) {
    return 'urgent';
  } else {
    return 'normal';
  }
};

export const getDateColorClass = (urgency: string): string => {
  switch (urgency) {
    case 'overdue':
      return 'text-red-600 font-bold';
    case 'urgent':
      return 'text-orange-600 font-semibold';
    case 'normal':
    default:
      return 'text-gray-700';
  }
};

export const getBgColor = (order: any, dateUrgency: string): string => {
  if (order.isManualPriority) return 'bg-purple-500';
  if (order.hasPartialDelivery) return 'bg-amber-500';
  if (dateUrgency === 'overdue') return 'bg-red-500';
  if (dateUrgency === 'urgent') return 'bg-orange-500';
  return 'bg-blue-500';
};